import { render, staticRenderFns } from "./boardEff.vue?vue&type=template&id=695a5a13&scoped=true&"
import script from "./boardEff.vue?vue&type=script&lang=js&"
export * from "./boardEff.vue?vue&type=script&lang=js&"
import style0 from "./boardEff.vue?vue&type=style&index=0&id=695a5a13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695a5a13",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QSelect,QBtnDropdown,QMarkupTable,QCheckbox,QInput,QIcon,QPopupProxy,QDate,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QSelect,QBtnDropdown,QMarkupTable,QCheckbox,QInput,QIcon,QPopupProxy,QDate,QCard,QCardSection}, component.options.components || {})
